import {
    SMS_GATEWAY_ERROR,
    SMS_GATEWAY_LOADING,
    GET_SMS_GATEWAY,
    POST_SMS_GATEWAY
} from "../types";

const initialState = {
    data:[],
    loading:false
}

export default function smsGatewayReducer (state = initialState, action) {

    switch(action.type){
        case SMS_GATEWAY_LOADING:
            return {
                ...state ,
                error : null ,
                loading : true
            }
        case SMS_GATEWAY_ERROR :
            return {
                ...state ,
                loading : false ,
                error : null
            }
        case GET_SMS_GATEWAY :
            return {
                ...state ,
                loading: false ,
                error : false ,
                data : action.payload
            }
        case POST_SMS_GATEWAY :
            return {
                ...state ,
                loading : false ,
                err:null ,
                data :[...state.data].concat(action.payload)
            }
        default: return state
    }

}

